/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '@angular/common';
import * as import2 from './page-container.component';
import * as import3 from '../navigation.service';
const styles_PageContainerComponent:any[] = ([] as any[]);
export const RenderType_PageContainerComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_PageContainerComponent,
  data: {}
}
);
export function View_PageContainerComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵqud(402653184,1,{viewContainerRef: 0}),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'container-shroud'
      ]
      ],[[
        2,
        'open',
        (null as any)
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵpid(131072,import1.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(16777216,[
      [
        1,
        3
      ]
      ,
      [
        'content',
        1
      ]

    ]
    ,(null as any),0,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(null as any),(ck,v) => {
    var co:import2.PageContainerComponent = v.component;
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform(co.open$));
    ck(v,1,0,currVal_0);
  });
}
function View_PageContainerComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-page-container',([] as any[]),[[
        2,
        'hidden',
        (null as any)
      ]
    ],(null as any),(null as any),View_PageContainerComponent_0,RenderType_PageContainerComponent)),
    import0.ɵdid(245760,(null as any),0,import2.PageContainerComponent,[
      import0.ElementRef,
      import3.NavigationService,
      import0.Injector,
      import0.ChangeDetectorRef
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).hidden;
    ck(v,0,0,currVal_0);
  });
}
export const PageContainerComponentNgFactory:import0.ComponentFactory<import2.PageContainerComponent> = import0.ɵccf('woa-page-container',import2.PageContainerComponent,View_PageContainerComponent_Host_0,{rootSelector: 'rootSelector'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvb3JjaGVzdHJhdGlvbi9wYWdlLWNvbnRhaW5lci9wYWdlLWNvbnRhaW5lci5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS9ydW5uZXIvd29yay93ZWItb3JkZXJpbmctYXBwL3dlYi1vcmRlcmluZy1hcHAvc3JjL2FwcC9vcmNoZXN0cmF0aW9uL3BhZ2UtY29udGFpbmVyL3BhZ2UtY29udGFpbmVyLmNvbXBvbmVudC50cyIsIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvb3JjaGVzdHJhdGlvbi9wYWdlLWNvbnRhaW5lci9wYWdlLWNvbnRhaW5lci5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvb3JjaGVzdHJhdGlvbi9wYWdlLWNvbnRhaW5lci9wYWdlLWNvbnRhaW5lci5jb21wb25lbnQudHMuUGFnZUNvbnRhaW5lckNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxkaXYgY2xhc3M9XCJjb250YWluZXItc2hyb3VkXCIgW2NsYXNzLm9wZW5dPVwib3BlbiQgfCBhc3luY1wiPlxuICAgIDxuZy1jb250YWluZXIgI2NvbnRlbnQ+PC9uZy1jb250YWluZXI+XG48L2Rpdj5cbiIsIjx3b2EtcGFnZS1jb250YWluZXI+PC93b2EtcGFnZS1jb250YWluZXI+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztNQ0FBO1FBQUE7UUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO2dCQUE4QjtJQUE2QjtJQUN2RDtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7SUFBc0M7SUFDcEM7Ozs7SUFGd0I7SUFBOUIsU0FBOEIsU0FBOUI7Ozs7O01DQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO2dCQUFBOzs7OztJQUFBO0tBQUE7OztJQUFBOztJQUFBO0lBQUEsU0FBQSxTQUFBOzs7In0=



// WEBPACK FOOTER //
// ./src/app/orchestration/page-container/page-container.component.ngfactory.ts